

export default [
	{
		path: '/wechatOperate',
		name: 'wechatOperate',
		meta: {
			text: '老板查账短链',
		},
		component: () => import('@/components/wechatOperate/index'),
	},

];
